// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanDto } from './IPlanDto';
import {
    IPlanDtoFromJSON,
    IPlanDtoFromJSONTyped,
    IPlanDtoToJSON,
    IPlanDtoToJSONTyped,
} from './IPlanDto';
import type { IReportHeader } from './IReportHeader';
import {
    IReportHeaderFromJSON,
    IReportHeaderFromJSONTyped,
    IReportHeaderToJSON,
    IReportHeaderToJSONTyped,
} from './IReportHeader';
import type { IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto } from './IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto';
import {
    IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON,
    IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped,
    IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoToJSON,
    IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped,
} from './IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
 */
export interface IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto {
    /**
     * 
     * @type {Array<IReportHeader>}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    headers?: Array<IReportHeader>;
    /**
     * 
     * @type {Array<IPlanDto>}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    plans?: Array<IPlanDto>;
    /**
     * 
     * @type {Date}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    last_updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    date_to?: Date;
    /**
     * 
     * @type {IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    content?: IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto;
    /**
     * 
     * @type {number}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    total_records?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    page_number?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    page_size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto
     */
    has_next?: boolean;
}

/**
 * Check if a given object implements the IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto(value: object): value is IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto {
    return true;
}

export function IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON(json: any): IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto {
    return IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'] == null ? undefined : ((json['headers'] as Array<any>).map(IReportHeaderFromJSON)),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanDtoFromJSON)),
        'last_updated_at': json['last_updated_at'] == null ? undefined : (new Date(json['last_updated_at'])),
        'date_from': json['date_from'] == null ? undefined : (new Date(json['date_from'])),
        'date_to': json['date_to'] == null ? undefined : (new Date(json['date_to'])),
        'content': json['content'] == null ? undefined : IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON(json['content']),
        'total_records': json['total_records'] == null ? undefined : json['total_records'],
        'page_number': json['page_number'] == null ? undefined : json['page_number'],
        'page_size': json['page_size'] == null ? undefined : json['page_size'],
        'has_next': json['has_next'] == null ? undefined : json['has_next'],
    };
}

export function IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoToJSON(json: any): IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto {
    return IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(value?: IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'] == null ? undefined : ((value['headers'] as Array<any>).map(IReportHeaderToJSON)),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanDtoToJSON)),
        'last_updated_at': value['last_updated_at'] == null ? undefined : ((value['last_updated_at']).toISOString()),
        'date_from': value['date_from'] == null ? undefined : ((value['date_from']).toISOString().substring(0,10)),
        'date_to': value['date_to'] == null ? undefined : ((value['date_to']).toISOString().substring(0,10)),
        'content': IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoToJSON(value['content']),
        'total_records': value['total_records'],
        'page_number': value['page_number'],
        'page_size': value['page_size'],
        'has_next': value['has_next'],
    };
}

